module.exports = __webpack_public_path__ + "img/icon1.09748fd8.png";